import { jsx, jsxs } from "react/jsx-runtime";
import { Text } from "@nxt-costco-com/forge-components";
import { SpaceXs, SpaceMd } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../Util/CostcoBox.js";
import { CategoryHeadingStyles, CategoryContent, BannerContainerStyles, BannerContentStyles } from "./styles.js";
function FourCorners({
  data,
  heading,
  isAdSetCostco = false,
  type = "category",
  uniqueId
}) {
  if (!data) {
    return null;
  }
  const tiles = data.slice(0, 4);
  if (type === "category") {
    if (isAdSetCostco) {
      return /* @__PURE__ */ jsx(
        CostcoBox,
        {
          sx: {
            alignItems: "flex-start",
            display: "flex",
            flex: 1,
            flexDirection: "row",
            flexWrap: "wrap",
            gap: SpaceMd,
            justifyContent: "center",
            marginBottom: SpaceXs,
            width: "100%"
          },
          children: tiles.map((component, index) => {
            return /* @__PURE__ */ jsx(
              CostcoBox,
              {
                sx: {
                  flex: 1,
                  height: `calc(50% - (${SpaceMd} / 2))`,
                  minWidth: `calc(50% - (${SpaceMd} / 2))`
                },
                children: component
              },
              `${uniqueId}_${index}`
            );
          })
        }
      );
    }
    return /* @__PURE__ */ jsxs(CostcoBox, { children: [
      /* @__PURE__ */ jsx(Text, { as: "h2", sx: CategoryHeadingStyles, children: heading }),
      /* @__PURE__ */ jsx(CategoryContent, { isAdSetCostco, children: tiles })
    ] }, uniqueId);
  }
  return /* @__PURE__ */ jsx(CostcoBox, { sx: BannerContainerStyles, children: /* @__PURE__ */ jsx(CostcoBox, { sx: BannerContentStyles, children: tiles }) }, uniqueId);
}
export {
  FourCorners
};
